import { useState, useEffect } from "react";
import { getBaseUrl } from "../utils/apiHelper";
import { useLocation } from "react-router-dom";

const EmailCodeVerify = () => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [step, setStep] = useState("request");
  const location = useLocation();

  useEffect(() => {
    // Auto-fill email from query parameter if present
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email");
    if (emailParam) setEmail(emailParam);
  }, [location.search]);

  const handleSendCode = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const res = await fetch(`${getBaseUrl()}/api/auth/send-verification-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (res.ok) {
        setStep("verify");
        setMessage("Verification code sent! Check your email.");
      } else {
        setMessage(data.message || "Failed to send code.");
      }
    } catch (err) {
      setMessage("Failed to send code.");
    }
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const res = await fetch(`${getBaseUrl()}/api/auth/verify-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, code })
      });
      const data = await res.json();
      if (res.ok) {
        setMessage("✅ Email verified! You can now log in.");
        setStep("done");
      } else {
        setMessage(data.message || "Verification failed.");
      }
    } catch (err) {
      setMessage("Verification failed.");
    }
  };

  return (
    <div className="form-container">
      <h2>Email Verification</h2>
      {step === "request" && (
        <form onSubmit={handleSendCode}>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            placeholder="Enter your email"
          />
          <button type="submit">Send Verification Code</button>
        </form>
      )}
      {step === "verify" && (
        <form onSubmit={handleVerifyCode}>
          <input
            type="text"
            value={code}
            onChange={e => setCode(e.target.value)}
            required
            placeholder="Enter verification code"
          />
          <button type="submit">Verify Code</button>
        </form>
      )}
      {message && <p>{message}</p>}
    </div>
  );
};

export default EmailCodeVerify;
